// @flow
import Handler from "./handler.js";

import mapKey, {LEFT, RIGHT, UP, DOWN} from "../components/mapkey.js";

const TIMEOUT = 500;

export default class Keyboard extends Handler {
	// XXX: https://github.com/facebook/flow/issues/3076
	handleKeydown: (ev: KeyboardEvent) => void;
	handleKeyup: (ev: KeyboardEvent) => void;

	debounceTimer: number;
	wasAtEdge: boolean = false;

	mount() {
		this.handleKeydown = this.handleKeydown.bind(this);
		this.handleKeyup = this.handleKeyup.bind(this);

		this.scroller.elem.addEventListener("keydown", this.handleKeydown);
		this.scroller.elem.addEventListener("keyup", this.handleKeyup);
	}

	unmount() {
		clearTimeout(this.debounceTimer);
		this.scroller.elem.removeEventListener("keydown", this.handleKeydown);
		this.scroller.elem.removeEventListener("keyup", this.handleKeyup);
	}

	getDirection(ev: KeyboardEvent) {
		if (ev.altKey || ev.ctrlKey || ev.metaKey || ev.shiftKey) { return null; }
		const key = mapKey(ev);

		const {horizontal} = this.scroller;
		const isScrollToStart = horizontal ? LEFT.includes(key) : UP.includes(key);
		const isScrollToEnd = horizontal ? RIGHT.includes(key) : DOWN.includes(key);
		if (!isScrollToStart && !isScrollToEnd) { return null; }

		return isScrollToStart ? "start" : "end";
	}

	clearDebounce = () => {
		this.scroller.setScrollHandler();
		this.debounceTimer = 0;
	};
	debounce() {
		const hadDebounce = Boolean(this.debounceTimer);
		clearTimeout(this.debounceTimer);
		this.debounceTimer = setTimeout(this.clearDebounce, TIMEOUT);
		return hadDebounce;
	}

	handleKeydown(ev: KeyboardEvent) {
		const {scroller} = this;
		const direction = this.getDirection(ev);
		if (!direction) { return; }

		const maxFreeScroll = scroller.getMaxFreeScrollInDirection(direction);
		const position = scroller.position.target;
		const canSnap = direction === "start"
			? (position > 0)
			: (position < scroller.position.max);
		if (!maxFreeScroll && !canSnap && !scroller.spring.running) { return; }

		ev.stopPropagation();

		if (!scroller.setScrollHandler(this)) {
			ev.preventDefault();
			return;
		}

		if (this.debounce()) { return; }
		this.wasAtEdge = !maxFreeScroll;

		if (this.wasAtEdge) {
			ev.preventDefault();
		}
	}

	handleScroll(currentScroll: number, lastScroll: number) {
		const {scroller} = this;
		scroller.clampOverflow(lastScroll, currentScroll);
	}

	handleKeyup(ev: KeyboardEvent) {
		const {scroller} = this;
		const direction = this.getDirection(ev);
		if (!direction || !this.wasAtEdge || scroller.scrollHandler !== this) { return; }
		if (this.wasAtEdge) {
			const position = scroller.position.target;
			scroller.snapToPosition(position + (direction === "start" ? -1 : 1),
				direction === "start" ? "end" : "start");
		} else {
			scroller.setScrollHandler();
		}
	}
}



// WEBPACK FOOTER //
// ./lib/scroller/keyboard.js